import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Form, Row, Col, Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { H4, H3, Btn, Breadcrumbs, } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken } from '../../../Utils/restUtils';
import { Wallet, WalletList, Search, Filter, Account, walletImportTitle, walletImportTableTitle, importFile, AddWalletMoney } from '../../../Constant';
import { ViewWallet, ViewWalletRole, postWalletImport, publicSampleDownloadWallet, viewAccount, viewAccountRole } from '../../../CommonUrl';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import PopupImport from '../../Common/Popup/popupImport';
import ImportWallet from '../../Common/Import/ImportWallet';
import CustomerFilter from '../../Common/CustomerFilter/CustomerFilter';

const WalletListContainer = () => {
    const [spinnerTrans, setspinnerTrans] = useState(true);
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const [customerLists, setCustomerList] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
        start: '',
        end: '',
        customerId: '',
        account_id: ''
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [dateRange, setDateRange] = useState([null, null]);
    const [currentPage, setCurrentPage] = useState(1);
    const [apiAccount, setapiAccount] = useState([]);
    const [startDate, endDate] = dateRange;
    const searchstb = useRef(null)
    const [isCustomer, setIsCustomer] = useState('');
    const [modalImport, setModalImport] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });
    const isAccount = useRef(null);
    const fileImport = <span className='billerqColor bolder '>
        <h3>{importFile}</h3>
    </span>

    useEffect(() => {
        fetchWallet(1);
        accountData();
    }, []);

    const WalletColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.si,
            width: '80px',
        },
        {
            name: <H4>Customer ID</H4>,
            id: 'subscriber_id',
            selector: row =>
                (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                    <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.CustomerId}`}>
                        {row.Sub}
                    </Link> : row.Sub,
            sortable: true,
            wrap: true,
        },
        {
            name: <H4>Name</H4>,
            id: 'name',
            selector: row => row.Customer,
            sortable: true,
            wrap: true,
        },
        {
            name: <H4>TXN ID</H4>,
            id: 'transaction_id',
            selector: row => row.Transaction,
            sortable: true,
            wrap: true,
        },
        {
            name: <H4>Date</H4>,
            id: 'paid_at',
            selector: row => row.Date,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Amount</H4>,
            id: 'amount',
            selector: row => row.Amount,
            sortable: true,
            center: true,
        },

        {
            name: <H4>Description</H4>,
            id: 'description',
            selector: row => row.Description,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Account</H4>,
            id: 'account_name',
            selector: row => row.Account,
            sortable: true,
            Wrap: true,
            center: true,
        },
    ];

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchWallet(currentPage, perPage, filters.search, filters.start, filters.end, filters.customerId, filters.account_id, column.id, newOrder);
    };

    const handleChange = (selectedOption) => {
        setIsCustomer(selectedOption);
    };

    const handleModalImport = () => {
        setModalImport(!modalImport);
    }

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };


    const fetchWallet = async (page, size = perPage, searchKey = '', start_date = '', end_date = '', customerId = '', accountId = '', sortBy = '', sortOrder = '') => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? ViewWallet +
            `?page=${page}&page_length=${size}&search=${searchKey}&start_date=${start_date}&end_date=${end_date}&customer_id=${customerId}&account_id=${accountId}&sort_by=${sortBy}&sort_order=${sortOrder}` : ViewWalletRole +
        `?page=${page}&page_length=${size}&search=${searchKey}&start_date=${start_date}&end_date=${end_date}&customer_id=${customerId}&account_id=${accountId}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setCustomerList(response?.data?.data.map((e, index) => {
                return {
                    si: SerialNo + index,
                    Ref: e.reference,
                    Sub: e.subscriber_id,
                    Date: e.paid_at,
                    Amount: `${authState.currency} ${e.amount}`,
                    Customer: e.customer_name,
                    Transaction: e.transaction_id,
                    Description: e.description,
                    Account: e.account_name,
                    CustomerId: e.customer_id,
                }
            }))
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const handlePageChange = page => {
        fetchWallet(page, perPage, filters.search, filters.start, filters.end, filters.customerId, filters.account_id, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchWallet(page, newPerPage, filters.search, filters.start, filters.end, filters.customerId, filters.account_id, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const accountData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAccount : viewAccountRole);
        if (data.status === true) {
            setapiAccount(data.data);
        } else {
            handleApiError(data.status);
        }
    };

    const handleFilter = async (e) => {
        e.preventDefault()
        const search = searchstb.current.value;
        const account_id = isAccount.current.value;
        const customer_id = isCustomer?.value;
        const start = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        setFilters({
            search,
            customer_id,
            account_id,
            start,
            end,
            account_id
        });
        fetchWallet(1, perPage, search, start, end, customer_id, account_id);
    };


    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={Wallet} parent="Customers" title={Wallet} />
            <Card>
                <CardHeader style={{ margin: '-25px 0 -40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{WalletList}</H3>
                    <div>
                        <CardBody className="dropdown-basic">
                            {(authState.userRole === 1 || authState.permissions.includes('store-customer')) &&
                                <Link to={`${process.env.PUBLIC_URL}/Customers/wallet-add`} className="btn btn-primary mr-4" style={{ marginLeft: '10px' }}>{AddWalletMoney}</Link>
                            }
                        </CardBody>
                    </div>
                </CardHeader>
                <CardBody>
                    <span className=''>
                        <Form className="needs-validation" noValidate onSubmit={handleFilter}>
                            <Row className="ps-3 gap-sm-3 gap-md-2 mb-4">
                                <Col sm="12" md='5' lg='2' className="form-element">
                                    <input className="form-control" placeholder={Search} type="text"
                                        ref={searchstb} />
                                </Col>
                                <Col sm="12" md="5" lg='2' className="form-element">
                                    <div style={{ position: 'relative', zIndex: 2 }}>
                                        <DatePicker
                                            className="form-control digits w-100"
                                            selectsRange={true}
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            isClearable={true}
                                            monthsShown={2}
                                            popperPlacement="bottom"
                                            calendarClassName='parallel-calendar'
                                            placeholderText='Select Date Range'
                                        />
                                    </div>

                                </Col>
                                <Col sm="12" md="5" lg="2" className="form-element">
                                    <CustomerFilter
                                        authState={authState}
                                        onCustomerChange={handleChange}
                                        handleApiError={handleApiError}
                                    />
                                </Col>
                                <Col sm="12" md="5" lg='2' className="form-element">
                                    <select className="form-select" ref={isAccount}>
                                        <option value="">{Account}</option>
                                        {apiAccount.map((values, index) => (
                                            <option key={index} value={values.id}>{values.name}</option>
                                        ))}
                                    </select>
                                </Col>
                                <Col sm="12" md="5" lg='1' className="custom-filtrs">
                                    <Btn attrBtn={{ color: "primary", }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>

                    <div className="order-history table-responsive">
                        <DataTable
                            columns={WalletColumns}
                            data={customerLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
            <PopupImport isOpen={modalImport} title={fileImport} toggler={handleModalImport} >
                <ImportWallet
                    setModal={setModalImport}
                    sampleImportApi={publicSampleDownloadWallet}
                    postImportApi={postWalletImport}
                    imporTitle={walletImportTitle}
                    tableTitle={walletImportTableTitle}
                    tablerenderFunc={fetchWallet}
                    currentPage={currentPage}
                    perPage={perPage}
                />
            </PopupImport>
        </Fragment>
    );
};

export default WalletListContainer;